import createAxiosInstance from './axios'

export const request = createAxiosInstance('', true)
